export default "__VITE_ASSET__C23ZcW29__"